var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_14483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 7.35779V17.9541C20.0004 19.6697 18.7004 20.9816 17.0004 20.9816H5.90039C5.90039 22.0917 6.80039 23 7.90039 23H18.0004C20.2004 23 22.0004 21.1835 22.0004 18.9633V9.37614C22.0004 8.26604 21.1004 7.35779 20.0004 7.35779Z",
    fill: "#0098DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1V3.01835H4C2.9 3.01835 2 3.92661 2 5.0367V17.1468C2 18.2569 2.9 19.1651 4 19.1651H16.2C17.3 19.1651 18.2 18.2569 18.2 17.1468V5.0367C18.2 3.92661 17.3 3.01835 16.2 3.01835H15.2V1H13.2V3.01835H7V1H5ZM4 8.06422H16.2V17.1468H4V8.06422Z",
    fill: "#0098DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 16.3395L11.3 14.9267L9 16.3395L9.6 13.6147L7.5 11.7982L10.3 11.5964L11.4 8.97253L12.5 11.4955L15.3 11.7982L13.2 13.6147L13.7 16.3395Z",
    fill: "#0098DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_14483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsFilled);
export default __webpack_public_path__ + "static/media/events--filled.a55517ce32f8d6c797bc8b2961a4a3c5.svg";
export { ForwardRef as ReactComponent };